module.exports = __webpack_public_path__ + "img/banner-1.0d5198a7.png";